import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import dataV from '@jiaminghi/data-view';
// 引入全局css
import './assets/scss/style.scss';
// 按需引入vue-awesome图标
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons/chart-bar.js';
import 'vue-awesome/icons/chart-area.js';
import 'vue-awesome/icons/chart-pie.js';
import 'vue-awesome/icons/chart-line.js';
import 'vue-awesome/icons/align-left.js';
// 引入element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

//引入echart
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
// 引入适配单位
import remStyle from './utils/rem'
Vue.config.remStyle = remStyle;

// 动画
import animated from 'animate.css'
Vue.use(animated);

// 数字翻滚器
import countTo from 'vue-count-to';
Vue.component('countTo', countTo);

// 列表滚动
import vueSeamlessScroll from 'vue-seamless-scroll'
Vue.use(vueSeamlessScroll);

//接口请求
import axios from 'axios'
Vue.prototype.$axios = axios

Vue.config.productionTip = false;

// 全局注册
Vue.component('icon', Icon);
Vue.use(dataV);

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');
